// extracted by mini-css-extract-plugin
export default {"status":"style_status__zfkMR","big":"style_big__4Jvn3"};